<ng-template
  #toastContent
  let-message
  let-isHtml="isHtml"
>
  <div
    [class]="
      'main-container flex items-start gap-spacing-xs ' + message.styleClass
    "
  >
    <i
      [class]="{
        'ph-fill ph-check-circle': message.severity === 'success',
        'ph ph-info': message.severity === 'info',
        'ph ph-warning': message.severity === 'warn',
        'ph ph-x-circle': message.severity === 'error',
        'flex align-items-center justify-content-center': true,
      }"
    ></i>
    <div class="flex gap-spacing-default flex-column">
      @if (message.summary.length) {
        <div class="message-title">
          {{ message.summary }}
        </div>
      }
      @if (isHtml) {
        <div
          class="message-details"
          [innerHTML]="message.detail"
        ></div>
      } @else {
        <div class="message-details">{{ message.detail }}</div>
      }
    </div>
  </div>
</ng-template>

<p-toast
  key="toast-prime-component"
  [position]="'top-right'"
>
  <ng-template
    pTemplate="message"
    let-message
  >
    <ng-container
      *ngTemplateOutlet="
        toastContent;
        context: { $implicit: message, isHtml: false }
      "
    />
  </ng-template>
</p-toast>

<p-toast
  key="toast-prime-component-innerHtml"
  [position]="'top-right'"
>
  <ng-template
    pTemplate="message"
    let-message
  >
    <ng-container
      *ngTemplateOutlet="
        toastContent;
        context: { $implicit: message, isHtml: true }
      "
    />
  </ng-template>
</p-toast>
